import { useTranslation } from "react-i18next";
import { useAgreementData } from "../../hooks";
import { AgreementGroupedDataSection, AgreementFields } from "../shared";
import { CollapsibleSection } from "@/components/CollapsibleSection";

export const statementFields: AgreementFields = [
  // Student status group
  { key: "is_student", type: "boolean", group: "student" },
  { key: "school_name", group: "student" },
  { key: "student_id_number", group: "student" },
  { key: "student_id_valid_until", group: "student", showExpiredWarning: true },
  { key: "student_id_attachments", type: "attachments", group: "student" },

  // Employment status group
  { key: "is_employed", type: "boolean", group: "employment" },
  { key: "employer_name", group: "employment" },
  {
    key: "employment_certificate_issue_date",
    group: "employment",
  },
  {
    key: "employment_certificate_attachments",
    type: "attachments",
    group: "employment",
  },

  // Voluntary sickness insurance group
  { key: "voluntary_sickness_insurance", type: "boolean", group: "insurance" },

  // Pension status group
  { key: "is_pensioner", type: "boolean", group: "pension" },
  { key: "pension_number", group: "pension" },
  { key: "pension_start_date", group: "pension" },
  { key: "pension_office_name", group: "pension" },

  // Disability pension group
  {
    key: "is_disability_pensioner",
    type: "boolean",
    group: "disability_pension",
  },
  { key: "disability_pension_number", group: "disability_pension" },
  { key: "disability_pension_start_date", group: "disability_pension" },
  {
    key: "disability_pension_end_date",
    group: "disability_pension",
    showExpiredWarning: true,
  },
  { key: "disability_pension_office_name", group: "disability_pension" },
  {
    key: "disability_pension_type",
    valueTranslationPrefix: "disabilityPensionTypes",
    group: "disability_pension",
  },
  {
    key: "disability_pension_description",
    group: "disability_pension",
  },

  // Visa status group
  { key: "has_valid_visa", type: "boolean", group: "visa" },
  { key: "visa_number", group: "visa" },
  { key: "visa_valid_until", group: "visa", showExpiredWarning: true },
  { key: "visa_attachments", type: "attachments", group: "visa" },

  // Polish card group
  { key: "has_polish_card", type: "boolean", group: "polish_card" },
  {
    key: "polish_card_valid_until",
    group: "polish_card",
    showExpiredWarning: true,
  },
  { key: "polish_card_attachments", type: "attachments", group: "polish_card" },

  // Residence card group
  { key: "has_residence_card", type: "boolean", group: "residence_card" },
  {
    key: "residence_card_valid_until",
    group: "residence_card",
    showExpiredWarning: true,
  },
  {
    key: "residence_card_attachments",
    type: "attachments",
    group: "residence_card",
  },

  // Other statements group
  { key: "watched_instructional_videos", type: "boolean", group: "other" },
  { key: "attachments", type: "attachments", group: "other" },
] as const;

export const AgreementStatementsSection = () => {
  const { t } = useTranslation();
  const { draft_statements, statements, questionnaire_attachments } =
    useAgreementData();

  return (
    <CollapsibleSection title={t("agreements.statements.title")}>
      <AgreementGroupedDataSection
        title=""
        fields={statementFields}
        draftData={draft_statements}
        confirmedData={statements}
        translationPrefix="questionnaires.statements"
        attachments={questionnaire_attachments}
      />
    </CollapsibleSection>
  );
};
